import React from 'react';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { AllSongsResultsScreen } from './AllSongsResultsScreen';

/** The route `/outreach/results` (design outreach-v2 n2). */
const AllSongsResultsViewComponent: React.FC = () => {
  const accountId = useAccountId();
  if (accountId === null) {
    return <LoadingView />;
  }
  return <AllSongsResultsScreen accountId={accountId} />;
};

export const AllSongsResultsView = TypedMemo(AllSongsResultsViewComponent);
